const initialState = {
  data: null,
  loading: false,
  error: null,
  lastUpdated: null,
  lastSuccessfulData: null // שמירת הנתונים האחרונים שהצליחו
};

const weatherReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_WEATHER_START':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'FETCH_WEATHER_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload,
        lastSuccessfulData: action.payload, // שמירת הנתונים המוצלחים
        error: null,
        lastUpdated: new Date().toISOString()
      };

    case 'FETCH_WEATHER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: state.lastSuccessfulData // שימוש בנתונים האחרונים שהצליחו במקום null
      };

    default:
      return state;
  }
};

export default weatherReducer;